module.exports = __webpack_public_path__ + "img/1440.33d9168a.jpg";